var exports = {
  "button": "x52a3aa3b--d53173--button",
  "button--desktop": "x52a3aa3b--d53173--button--desktop",
  "button--unread": "x52a3aa3b--d53173--button--unread",
  "button--desktop--unread": "x52a3aa3b--d53173--button--desktop--unread",
  "title": "x52a3aa3b--d53173--title",
};

module.exports = exports;
